import { useQuery } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'

export enum EDomicileType {
  PROVINCES = 'provinces',
  CITIES = 'cities',
  DISTRICTS = 'districts',
  SUBDISTRICTS = 'subdistricts',
  ZIP_CODE = 'zipCode',
}

export type TListDomicilePayload = {
  type: EDomicileType
  province?: string
  city?: string
  district?: string
  subdistrict?: string
  search?: string
}

export type TListDomicileResponse = {
  success: boolean
  traceId: string
  error?: {
    code: string
    message: string
    errors: any[]
  }
  meta: unknown
  result: {
    data: string[]
  }
}

async function getListDomicileAPI(
  { type, province, city, district, subdistrict, search }: TListDomicilePayload,
  useMockServer: boolean = false,
): Promise<TListDomicileResponse> {
  try {
    const result = await axiosInstance({
      baseURL: useMockServer
        ? process.env.NEXT_PUBLIC_MOCK_API_URL
        : process.env.NEXT_PUBLIC_API_URL,
      url: `/survey/domicile`,
      method: 'get',
      params: {
        type,
        province,
        city,
        district,
        subdistrict,
        search,
      },
    })

    return result?.data
  } catch (error: any) {
    throw error?.response?.data
  }
}

export default function useGetListDomicileQuery(
  { type, province, city, district, subdistrict, search }: TListDomicilePayload,
  enabled: boolean,
) {
  const { data, isPending, isError, error, refetch, isFetching } = useQuery({
    queryKey: ['get_list_domicile', type, province, city, district, subdistrict, search],
    queryFn: () => getListDomicileAPI({ type, province, city, district, subdistrict, search }),
    enabled,
  })

  return {
    data,
    isPending,
    isError,
    error,
    refetch,
    isFetching,
  }
}
